/* Buy Now label patch — July 2026
   Rewrites the per-template "BUY IT NOW" label
   to "Buy Now" (button CSS uppercases it). Remove once the
   buy_it_now block labels are updated per product template. */
(function () {
  function relabel(scope) {
    (scope || document).querySelectorAll('.bpdp-bin-btn').forEach(function (btn) {
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && /buy\s+it\s+now/i.test(node.textContent)) {
          node.textContent = ' Buy Now ';
        }
      });
      if (btn.dataset.binLabel && /buy\s+it\s+now/i.test(btn.dataset.binLabel)) {
        btn.dataset.binLabel = 'Buy Now';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { relabel(); });
  } else {
    relabel();
  }
  document.addEventListener('shopify:section:load', function (e) { relabel(e.target); });
})();

/* PDP installments patch — July 2026
   Injects a Shop Pay 4-payment line under the buy-box price
   (.bpdp-price) for prices in Shop Pay's 4-pay range ($50–$999.99).
   Recomputes on variant change. Remove once payment_terms is
   rendered natively in bushnell-product-main.liquid. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function parseCents(text) {
    var m = (text || '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }
  function render() {
    document.querySelectorAll('.bpdp-price').forEach(function (priceRow) {
      var current = priceRow.querySelector('[data-bpdp-price-current]');
      if (!current || !priceRow.parentElement) return;
      var cents = parseCents(current.textContent);
      var el = priceRow.parentElement.querySelector('.bn-installments');
      var fourPay = cents && cents >= 5000 && cents <= 99999;
      /* Monthly financing window ($1,000\u2013$17,500): 12-month estimate */
      var monthly = cents && cents > 99999 && cents <= 1750000;
      if (!fourPay && !monthly) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement('div');
        el.className = 'bn-installments';
        priceRow.insertAdjacentElement('afterend', el);
      }
      el.innerHTML = fourPay
        ? '4 interest-free payments of <strong>' + money(Math.round(cents / 4)) + '</strong> with <span class="bn-installments__badge">Shop Pay</span>'
        : 'As low as <strong>$' + Math.ceil(cents / 12 / 100).toLocaleString() + '/mo</strong> with <span class="bn-installments__badge">Shop Pay</span>';
    });
  }
  function init() {
    render();
    document.querySelectorAll('.bpdp-price [data-bpdp-price-current]').forEach(function (node) {
      new MutationObserver(render).observe(node, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', render);
})();

/* Delivery promise — July 2026
   Concrete shipping line under the buy-box price/installments.
   NOTE: confirm the 2 PM CT cutoff with fulfillment before go-live. */
(function () {
  function init() {
    var priceRow = document.querySelector('.bpdp-price');
    if (!priceRow || !priceRow.parentElement || document.querySelector('.bn-delivery')) return;
    var el = document.createElement('div');
    el.className = 'bn-delivery';
    el.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Free shipping on orders over $99';
    var after = priceRow.parentElement.querySelector('.bn-installments') || priceRow;
    after.insertAdjacentElement('afterend', el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ATC button price — July 2026
   Base product alone: the buy-box price sits directly above the button
   (and the native sticky bar shows it at left), so the inline "— $599.99"
   in ADD TO CART buttons is duplication — keep it stripped.
   With a "Complete Your Setup" add-on checked: the button total is no
   longer a duplicate (base + add-on), so SHOW the native
   [data-bpdp-atc-total] span — the section JS keeps it in sync.
   The native button rebuilds its label after load, so a MutationObserver
   keeps sweeping. */
(function () {
  var PRICE_RE = /\s*[\u2014\u2013-]\s*\$[\d,]+(?:\.\d\d)?/;

  /* Separator lives on the span so it appears/disappears with it — the
     literal "— " text node from the template gets stripped below. */
  var css = document.createElement('style');
  css.textContent = '[data-bpdp-atc-total]::before { content: "\\2014\\00a0"; }';
  document.head.appendChild(css);

  function addonChecked() {
    return !!document.querySelector('.bpdp-addon__check:checked');
  }

  function cleanBtn(btn) {
    var total = btn.querySelector('[data-bpdp-atc-total]');
    var show = total && addonChecked();
    /* Hide price-only child elements (any depth) — except the managed total */
    btn.querySelectorAll('*').forEach(function (el) {
      if (el === total) return;
      if (/^\$[\d,]+(?:\.\d\d)?$/.test((el.textContent || '').trim())) {
        el.style.display = 'none';
      }
    });
    if (total) total.style.display = show ? '' : 'none';
    /* Strip literal "— $x" prices + trailing dashes from ALL text nodes —
       the sticky bar wraps its label in a span, which previously left an
       orphan "ADD TO CART —"; the separator is re-added via CSS on the
       total span when it is visible. Skip text inside the total span. */
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (total && total.contains(node)) continue;
      if (PRICE_RE.test(node.textContent)) {
        node.textContent = node.textContent.replace(PRICE_RE, ' ');
      }
      node.textContent = node.textContent.replace(/\s*[\u2014\u2013]\s*$/, ' ');
    }
  }

  function sweep() {
    document.querySelectorAll('button, a[class*="btn"], a[class*="button"]').forEach(function (btn) {
      var t = btn.textContent || '';
      if (!/add\s+to\s+cart/i.test(t)) return;
      if (/\$\s?[\d,]+/.test(t) || /[\u2014\u2013]\s*$/.test(t.trim()) || btn.querySelector('[data-bpdp-atc-total]')) {
        cleanBtn(btn);
      }
    });
    /* Sticky ATC bar: mirror the running total into its price. The native
       total span is base + checked add-ons (just base when none checked),
       so the sticky price stays correct in every state. Only write on
       change to avoid a MutationObserver feedback loop. */
    var totalSpan = document.querySelector('[data-bpdp-atc-total]');
    var stickyPrice = document.querySelector('.bpdp-sticky__price');
    if (totalSpan && stickyPrice) {
      var v = (totalSpan.textContent || '').trim();
      if (v && stickyPrice.textContent.trim() !== v) stickyPrice.textContent = v;
    }
  }

  function init() {
    sweep();
    new MutationObserver(function () { sweep(); }).observe(document.body, { childList: true, subtree: true });
    /* Add-on toggles don't always mutate the DOM — re-sweep on change. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('bpdp-addon__check')) sweep();
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Lazy-load pass — July 2026
   Shogun/BigCommerce-era PDP content ships images and video iframes
   with no loading attributes. Mark everything well below the fold
   lazy + async-decoded to cut initial payload on long PDPs. */
(function () {
  function init() {
    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.top > window.innerHeight * 1.5) {
        img.setAttribute('loading', 'lazy');
      }
      img.setAttribute('decoding', 'async');
    });
    document.querySelectorAll('iframe:not([loading])').forEach(function (frame) {
      frame.setAttribute('loading', 'lazy');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
